'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
type ControlBarActionTooltipProps = {
  children: ReactElement;
  label: string;
  portalContainer?: HTMLElement | null;
};
export default function ControlBarActionTooltip(t0) {
  const $ = _c(8);
  const {
    children,
    label,
    portalContainer
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <TooltipTrigger asChild={true}><span className="inline-flex">{children}</span></TooltipTrigger>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label || $[3] !== portalContainer) {
    t2 = <TooltipContent side="top" sideOffset={8} portalContainer={portalContainer} className="bg-vive-primary-70 text-vive-primary-20 rounded-sm">{label}</TooltipContent>;
    $[2] = label;
    $[3] = portalContainer;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <Tooltip>{t1}{t2}</Tooltip>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}